import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CareerTestPage from "../pages/career-test/page";
import SubjectGuidePage from "../pages/subject-guide/page";
import StudyStylePage from "../pages/study-style/page";
import IqTestPage from "../pages/iq-test/page";
import LiteracyTestPage from "../pages/literacy-test/page";
import EnglishTestPage from "../pages/english-test/page";
import LoginPage from "../pages/login/page";
import FindAccountPage from "../pages/find-account/page";
import ResetPasswordPage from "../pages/reset-password/page";
import DashboardPage from "../pages/dashboard/page";
import MyProfilePage from "../pages/my-profile/page";
import AcademyDetailPage from "../pages/academy/page";
import InquiryPage from "../pages/inquiry/page";
import MyResultsPage from "../pages/my-results/page";
import AdminPage from "../pages/admin/page";
import TermsPage from "../pages/terms/page";
import PrivacyPage from "../pages/privacy/page";
import RequireAuth from "../components/feature/RequireAuth";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/career-test",
    element: (
      <RequireAuth>
        <CareerTestPage />
      </RequireAuth>
    ),
  },
  {
    path: "/subject-guide",
    element: (
      <RequireAuth>
        <SubjectGuidePage />
      </RequireAuth>
    ),
  },
  {
    path: "/study-style",
    element: (
      <RequireAuth>
        <StudyStylePage />
      </RequireAuth>
    ),
  },
  {
    path: "/iq-test",
    element: (
      <RequireAuth>
        <IqTestPage />
      </RequireAuth>
    ),
  },
  {
    path: "/literacy-test",
    element: (
      <RequireAuth>
        <LiteracyTestPage />
      </RequireAuth>
    ),
  },
  {
    path: "/english-test",
    element: (
      <RequireAuth>
        <EnglishTestPage />
      </RequireAuth>
    ),
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/find-account",
    element: <FindAccountPage />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordPage />,
  },
  {
    path: "/dashboard",
    element: <DashboardPage />,
  },
  {
    path: "/my-profile",
    element: (
      <RequireAuth>
        <MyProfilePage />
      </RequireAuth>
    ),
  },
  {
    path: "/academy/:academyId",
    element: <AcademyDetailPage />,
  },
  {
    path: "/inquiry",
    element: <InquiryPage />,
  },
  {
    path: "/my-results",
    element: (
      <RequireAuth>
        <MyResultsPage />
      </RequireAuth>
    ),
  },
  {
    path: "/terms",
    element: <TermsPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "/admin",
    element: (
      <RequireAuth>
        <AdminPage />
      </RequireAuth>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;